export default __webpack_public_path__ + "static/tts-70745f8219f65319ef8af244b2ae528b.webm";